import React from 'react';
import { Alert, Card, Col, Row } from 'react-bootstrap';

export default function RecoveryLimitations() {
  return (
    <section className="mt-5" aria-labelledby="recovery-limitations-heading">
      <h2 id="recovery-limitations-heading" className="h3">
        History &amp; limitations
      </h2>

      <Alert variant="warning">
        <strong>Incapacity and steward sessions are intentionally unavailable.</strong>{' '}
        This UI does not let another person claim that an owner cannot act, and
        it never presents institutional custody as complete.
      </Alert>

      <Row className="g-3">
        <Col lg={6}>
          <Card className="h-100">
            <Card.Body>
              <Card.Title as="h3" className="h5">
                What works in this slice
              </Card.Title>
              <ul className="mb-0">
                <li>Personal adult keyholders who each accept their role.</li>
                <li>An owner-chosen threshold of at least two.</li>
                <li>Registered devices with caller-supplied public keys.</li>
                <li>
                  Authenticated lockout drills with delay, expiry, decisions,
                  cancellation, and server-recorded completion states.
                </li>
                <li>
                  Request-bound client crypto for activation, sealed
                  approvals, and target-device completion. Activation wraps
                  the owner’s unlocked adult-chat identity. Completing on the
                  named device installs that identity and rotates the circle
                  to a new version for the same keyholders. This still
                  requires a signed-in session.
                </li>
              </ul>
            </Card.Body>
          </Card>
        </Col>
        <Col lg={6}>
          <Card className="h-100 recovery-unavailable-card">
            <Card.Body>
              <Card.Title as="h3" className="h5">
                Required before incapacity support
              </Card.Title>
              <ul className="mb-0">
                <li>Evidence rules for a claim that the owner cannot act.</li>
                <li>A hard maximum steward-session duration.</li>
                <li>A defined renewal ceremony and objection path.</li>
                <li>
                  Rules for transfer to a valid power of attorney, guardianship,
                  estate process, or other formal authority.
                </li>
                <li>
                  Real, audited institution integrations and institution-required
                  approval policy.
                </li>
              </ul>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <p className="mt-3">
        Havn Sparebank and Stiftelsen Åpen Dør are design proposals only. They
        cannot be selected, receive no custody, and provide no safety guarantee
        in this release. No government body is a recovery-circle holder.
      </p>
      <p className="text-body-secondary">
        Recovery applies only to the owner’s adult-chat keys. It does not open
        another adult’s keys, class chat, or a temporary steward session.
      </p>
    </section>
  );
}
